<template>
  <div v-loading="loading" class="home-wrapper">
    <div class="home">
      <div class="step-wrapper">
        <div class="title">数据大屏创建流程</div>
        <div class="step">
          <div v-for="(item, index) in stepList" :key="index" class="step-item" @mouseenter="handleActiveStep(index)" @mouseleave="handleEnableStep" @click="handleToPage(item.path)">
            <div class="item_img">
              <img v-if="index === activeStep" :src="item.activeImg" alt="">
              <img v-else :src="item.img" alt="">
            </div>
            <div class="item_label">{{ item.label }}</div>
          </div>
        </div>
      </div>
      <div class="screen-wrapper">
        <div class="screen-main">
          <div class="tabs">
            <div v-for="(item, index) in tabList" :key="index"
                 class="tabs-item" :class="activeTab === index ? 'active-tab' : ''"
                 @click="activeTab = index">
              {{ item }}
            </div>
          </div>
          <div class="screen-list">
            <ScreenTemplates v-if="activeTab === 0" />
            <MyScreens v-else />
          </div>
        </div>
      </div>
      <ChangePasswordDialog v-if="dialogShow" :title="systemInfo.systemName" :background-img="systemInfo.systemLoginBackground" @close="dialogShow = false"></ChangePasswordDialog>
    </div>
  </div>
</template>

<script>
import ScreenTemplates from './components/screenTemplates.vue'
import MyScreens from './components/myScreens.vue'
import ChangePasswordDialog from './components/changePasswordDialog.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  components: {
    ScreenTemplates,
    MyScreens,
    ChangePasswordDialog,
  },
  data () {
    return {
      loading: false,
      activeStep: null,
      stepList: [
        { label: '选择模板', path: '/template', img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/home/step-1.png', activeImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/home/step-1-active.png' },
        { label: '创建大屏', path: '/screen', img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/home/step-2.png', activeImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/home/step-2-active.png' },
        { label: '设置大屏', path: '/screen', img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/home/step-3.png', activeImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/home/step-3-active.png' },
        { label: '查看大屏', path: '/screen', img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/home/step-4.png', activeImg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/home/step-4-active.png' },
      ],
      activeTab: 0,
      tabList: ['大屏模板', '我的大屏'],
      dialogShow: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'systemInfo']),
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (to.redirectedFrom) { // vue-router redirect不会刷新页面，需要判断并刷新
        window.location.reload()
      }
    })
  },
  async created () {
    try {
      this.loading = true
      // 判断是否是第一次登录
      if (this.userInfo.passwordInitFlag === 1) {
      // 修改密码弹窗
        this.dialogShow = true
      }
    } catch (e) {
      this.$error(e)
    } finally {
      this.loading = false
    }
  },
  methods: {
    handleToPage (path) {
      this.$router.push({ path })
    },
    handleActiveStep (val) {
      this.activeStep = val
    },
    handleEnableStep () {
      this.activeStep = null
    },
  },
}
</script>

<style lang="scss" scoped>
.home-wrapper{
  height: 100% !important;
  overflow-y: auto;
}
.home{
  height: 100%;
  overflow: hidden;
  background: url('https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/home/home-bg.png') 0 -60px no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  .step-wrapper{
    width:1200px;
    display: flex;
    flex-direction: column;
    // align-items: center;
    margin-bottom: 50px;
    .title{
      margin: 30px  0 ;
      // height: 30px;
      // width: 240px;
      font-size: 22px;
      font-weight: bold;
      color: #1C1C1C;
      // background: url('https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/home/step-title.png');
    }
    .step{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 930px;
      margin-left: 135px;
      .step-item{
        cursor: pointer;
        &:hover{
          color: #3269FF;
        }
        .item_img{
          width: 60px;
          height: 70px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .screen-wrapper{
    flex: 1;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;

    .tabs{
      min-width: 1200px;
      display: flex;
      border-bottom: 1px solid #E8E8E8;
      margin-bottom: 15px;
      .tabs-item{
        margin-right: 40px;
        margin-bottom: 10px;
        font-size: 22px;
        font-weight: bold;
        color: #4E4E4E;
        cursor: pointer;
      }
      .active-tab{
        color: #1C1C1C;
        position: relative;
        &::before{
          position: absolute;
          content: "";
          width: 30px;
          height: 3px;
          background: #3269FF;
          border-radius: 2px;
          left: 29px;
          bottom: -12px;
        }
      }
    }
    .screen-main {
      height: 100%;
      overflow: hidden;
      display:flex;
      flex-direction: column;
    }
    .screen-list{
      flex:1;
      height:100%;
      overflow: auto;
    }
  }
}
</style>
